import React from 'react';
import './ToggleSwitch.css';
import LockIcon from './LockIcon/LockIcon';
import AnimatedLockerIcon from './AnimatedLockerIcon/AnimatedLockerIcon';

export interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  width?: number;
  disabled?: boolean;
  loading?: boolean;
  marginLeft?: number;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  width = 100,
  disabled,
  marginLeft = 0,
  loading = false
}) => {
  return (
    <div className="checkbox" style={{ width, marginLeft: marginLeft }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ width }}
        disabled={disabled || loading}
      />
      <span className="icon">{<LockIcon loading={loading} locked={!checked} width={28} height={28} />}</span>
    </div>
  );
};

export default ToggleSwitch;
